import { FunctionComponent } from "react";
import styled from "styled-components";
import theme from "../theme";

const InputCheckbox = styled.input`
  margin: 0 ${theme.unit}px ${theme.unit}px 0;
  width: 16px;
  height: 16px;
  border: 1px solid ${theme.colors.black};
  border-radius: 0;
  appearance: none;
  vertical-align: -webkit-baseline-middle;
  background: ${theme.colors.white};

  &:checked {
    background: ${theme.colors.blue};
    padding: 1px;
    background-clip: content-box;
  }
`;

const Wrapper: FunctionComponent<any> = (props) => {
  return <InputCheckbox {...{ ...props, ...props.input }} />;
};

export default Wrapper;
